module.exports = __webpack_public_path__ + "static/media/country_sz.59cc1af3.webp";